import React, { useEffect, useState } from "react";
import classes from "./Leaderboard.module.css";
import Header from "../components/Header";
import BottomNavbar from "../components/BottomNavbar";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import Lottie from "lottie-react";
import leaderboardAnimation from "../animations/leaderboardAnimation.json";
import { getLeaderboard ,getmegaQuizeLeaderboard } from "../http/http";
import { useDispatch, useSelector } from "react-redux";
import MediumLoader from "../components/Loaders/MediumLoader";
import { useTranslation } from "react-i18next";
import { removeUserToken } from "../store/slices/userTokenSlice";
import { toast } from "react-toastify";

const Leaderboard = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const { userToken } = useSelector(
        (state) => state.persisted.userTokenSlice
    );

    const [loading, setLoading] = useState(true);

    const [activeBoard, setActiveBoard] = useState("weekly");

    const [weeklyLeaderboard, setWeeklyLeaderboard] = useState([]);
    const [monthlyLeaderboard, setMonthlyLeaderboard] = useState([]);

    const fetchLeaderboard = async () => {
        try {
            setLoading(true);

            const response = await getLeaderboard(userToken);
            const response1 = await getmegaQuizeLeaderboard();

            // Example response structure
            setWeeklyLeaderboard(
                response?.data?.result || []
            );

            setMonthlyLeaderboard(
                response1?.data.data || []
            );

            setLoading(false);
        } catch (error) {
            setLoading(false);

            if (error?.response?.status === 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate("/");
            } else {
                toast.error(
                    error?.response?.data?.error?.error ||
                    error?.response?.error?.error ||
                    error?.response?.error ||
                    "Something Went Wrong!"
                );
            }
        }
    };

    useEffect(() => {
        fetchLeaderboard();
    }, []);

    const currentLeaderboard =
        activeBoard === "weekly"
            ? weeklyLeaderboard
            : monthlyLeaderboard;

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.header_section}>
                    <div
                        className={classes.back_button}
                        onClick={() => navigate(-1)}
                    >
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>
                        {t("55")}
                    </h2>
                </div>

                <div className={classes.leaderboard_container}>
                    <Lottie
                        animationData={leaderboardAnimation}
                        loop
                        autoPlay
                        className={classes.leaderboard_animation}
                    />

                    {/* Tabs */}
                    <div className={classes.leaderboard_tabs}>
                        <button
                            className={`${classes.tab_btn} ${
                                activeBoard === "weekly"
                                    ? classes.active_tab
                                    : ""
                            }`}
                            onClick={() => {setActiveBoard("weekly")}}
                        >
                            Weekly
                        </button>

                        <button
                            className={`${classes.tab_btn} ${
                                activeBoard === "monthly"
                                    ? classes.active_tab
                                    : ""
                            }`}
                            onClick={() =>{ setActiveBoard("monthly")}}
                        >
                            Mega Quiz
                        </button>
                    </div>

                    {loading ? (
                        <MediumLoader />
                    ) : currentLeaderboard?.length > 0 ? (
                        currentLeaderboard.map((user, index) => (
                            <div
                                className={classes.leaderboard_item}
                                key={user.id || index}
                            >
                                <div
                                    className={
                                        classes.leaderboard_section_one
                                    }
                                >
                                    <div
                                        className={
                                            classes.user_profile_container
                                        }
                                    >
                                        <img
                                            src={
                                                user?.image ||
                                                "/assets/images/dummy.png"
                                            }
                                            alt="User"
                                            className={
                                                classes.user_profile_image
                                            }
                                        />

                                        <span
                                            className={
                                                classes.rank_badge
                                            }
                                        >
                                            {index + 1}
                                        </span>
                                    </div>

                                    <div
                                        className={
                                            classes.user_details_container
                                        }
                                    >
                                        <h4
                                            className={
                                                classes.user_name
                                            }
                                        >
                                            {user?.name ||
                                                user?.username ||
                                                t("17")}
                                        </h4>

                                        <p
                                            className={
                                                classes.user_score
                                            }
                                        >
                                            <b>{t("18")}</b>{" "}
                                            {user?.total_points || 0}
                                        </p>
                                    </div>
                                </div>

                                <div
                                    className={
                                        classes.user_points_container
                                    }
                                >
                                    <img
                                        src="/assets/images/tag.png"
                                        alt="Tag"
                                        className={
                                            classes.tag_image
                                        }
                                    />

                                    <span
                                        className={
                                            classes.user_points
                                        }
                                    >
                                        {user?.total_points || 0}
                                    </span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className={classes.no_data}>
                            No leaderboard data found.
                        </div>
                    )}
                </div>
            </div>

            <BottomNavbar active={3} />
        </>
    );
};

export default Leaderboard;